var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"custom-progress"},[_c('div',{class:['block-1', _vm.propsActive === 0 ? 'active' : ''],style:(_vm.block1Style())}),_c('div',{class:['block-2', _vm.propsActive === 1 ? 'active' : ''],style:(_vm.block2Style())}),_c('div',{class:['block-3', _vm.propsActive === 2 ? 'active' : ''],style:(_vm.block3Style())})])
}
var staticRenderFns = []

export { render, staticRenderFns }